"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  angular.module("damages.askSomeone", ["ui.router", "common"]);
})();

(function () {
  "use strict";

  var moduleName = "damages.askSomeone";
  var componentName = "askSomeone";

  var bindings = {
    resolve: "<?",
    damage: "<?"
  };

  var templateUrl = "app/pages/damages/askSomeone/askSomeone.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, $window, UsersService, VehiclesService, CustomListsService, DocumentRequestsService, DamagesService) {
      _classCallCheck(this, Controller);

      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$window = $window;
      this.UsersService = UsersService;
      this.VehiclesService = VehiclesService;
      this.DocumentRequestsService = DocumentRequestsService;
      this.CustomListsService = CustomListsService;
      this.DamagesService = DamagesService;

      console.log(moduleName + "/" + componentName);

      this.infos = {};
    }

    _createClass(Controller, [{
      key: "setMode",
      value: function setMode(mode) {
        this.mode = mode;

        if (this.mode === "driver") {
          this.infos.userName = this.driver.firstName + " " + this.driver.lastName;
          this.infos.phoneToUse = this.driver.cellularPhone;
          this.infos.emailToUse = this.driver.email;
        } else if (this.mode === "manager" && this.manager) {
          this.infos.userName = this.manager.firstName.trim() + " " + this.manager.lastName.trim();
          this.infos.phoneToUse = this.manager.cellularPhone;
          this.infos.emailToUse = this.manager.email;
        } else {
          this.infos.phoneToUse = null;
          this.infos.emailToUse = null;
          this.infos.userName = "???";
        }
      }
    }, {
      key: "close",
      value: function close() {
        console.log("$scope", this.$scope);

        if (this.$scope.$parent) {
          this.$scope.$parent.$close();
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  this.damage = this.resolve.params.damage;

                  console.log("damage", this.damage);

                  if (!(this.damage && this.damage.driverId)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 6;
                  return this.UsersService.getById(this.damage.driverId);

                case 6:
                  this.driver = _context.sent;

                  console.log("driver", this.driver);

                case 8:
                  if (!(this.damage && this.damage.managerId)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 11;
                  return this.UsersService.getById(this.damage.managerId);

                case 11:
                  this.manager = _context.sent;

                  console.log("manager", this.manager);

                case 13:
                  if (!(this.damage && this.damage.vehicleId)) {
                    _context.next = 18;
                    break;
                  }

                  _context.next = 16;
                  return this.VehiclesService.getById(this.damage.vehicleId);

                case 16:
                  this.vehicle = _context.sent;

                  console.log("vehicle", this.vehicle);

                case 18:
                  this.setMode("driver");
                  _context.next = 25;
                  break;

                case 21:
                  _context.prev = 21;
                  _context.t0 = _context["catch"](0);

                  console.error(_context.t0);

                  this.close();

                case 25:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[0, 21]]);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "save",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var phone;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!this.infos.phoneToUse) {
                    _context2.next = 9;
                    break;
                  }

                  phone = this.infos.phoneToUse.replace(/[\s.\-()]/g, "");

                  if (/^00[1-9]\d{6,13}$/.test(phone)) {
                    phone = "+" + phone.slice(2);
                  } else if (/^0\d{9}$/.test(phone)) {
                    phone = "+33" + phone.slice(1);
                  }

                  if (!/^\+[1-9]\d{6,14}$/.test(phone)) {
                    _context2.next = 7;
                    break;
                  }

                  this.infos.phoneToUse = phone;
                  _context2.next = 9;
                  break;

                case 7:
                  Notiflix.Notify.failure("Le format du portable n'est pas valide (format attendu : +33XXXXXXXXX ou 0XXXXXXXXX)");
                  return _context2.abrupt("return");

                case 9:
                  if (!(!this.infos.emailToUse && !this.infos.phoneToUse)) {
                    _context2.next = 13;
                    break;
                  }

                  Notiflix.Notify.failure("Un email ou un téléphone est nécessaire");
                  _context2.next = 36;
                  break;

                case 13:
                  if (this.infos.userName) {
                    _context2.next = 17;
                    break;
                  }

                  Notiflix.Notify.failure("Le nom du contact est nécessaire");
                  _context2.next = 36;
                  break;

                case 17:
                  _context2.prev = 17;

                  Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");

                  _context2.prev = 19;
                  _context2.next = 22;
                  return this.DamagesService.customPost("documentRequest", {
                    damageId: this.damage._id,
                    contactName: this.infos.userName,
                    email: this.infos.emailToUse,
                    phone: this.infos.phoneToUse
                  });

                case 22:
                  Notiflix.Notify.success("Envoi réussi");
                  _context2.next = 28;
                  break;

                case 25:
                  _context2.prev = 25;
                  _context2.t0 = _context2["catch"](19);

                  Notiflix.Notify.failure("Echec de l'envoi");

                case 28:

                  Notiflix.Loading.remove();

                  this.close();
                  _context2.next = 36;
                  break;

                case 32:
                  _context2.prev = 32;
                  _context2.t1 = _context2["catch"](17);

                  Notiflix.Loading.remove();
                  console.error(_context2.t1);

                case 36:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[17, 32], [19, 25]]);
        }));

        function save() {
          return _ref2.apply(this, arguments);
        }

        return save;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();